const formGuests = document.querySelector('[data-js="formGuests"]');
const formGuestsInput = document.querySelector("#f-search-guests");
let formGuestsInputs = document.querySelector(".f-search-guests");
const formGuestsInputDesktop = document.querySelector(
  "#f-search-guests-desktop"
);
const formGuestsSubmit = document.querySelector("#submit-guests");

const guestBtn = document.querySelectorAll(".f-search-guests");

if (formGuests) {
  for (let i = 0; i < guestBtn.length; i++) {
    window.addEventListener("load", function () {
      if (formGuestsInputs.value === "") {
        let btnText = guestPlaceholder;
        guestBtn[i].value = "";
        guestBtn[i].placeholder = btnText;
      }
    });

    formGuestsInput.addEventListener("click", function () {
      $("#m-guests").modal("show");
      updateValues();
    });
    if (formGuestsInputDesktop) {
      formGuestsInputDesktop.addEventListener("click", function () {
        $("#m-guests").modal("show");
        updateValues();
      });
    }
    formGuestsSubmit.addEventListener("click", function () {
      updateValues();
    });

    const guestOptions = document.querySelector("#guests-input-options"),
      adultsSubsBtn = document.querySelector("#adults-subs-btn"),
      adultsAddBtn = document.querySelector("#adults-add-btn"),
      childrenSubsBtn = document.querySelector("#children-subs-btn"),
      childrenAddBtn = document.querySelector("#children-add-btn"),
      smallChildrenSubsBtn = document.querySelector("#small-children-subs-btn"),
      smallChildrenAddBtn = document.querySelector("#small-children-add-btn"),
      animalsSubsBtn = document.querySelector("#animals-subs-btn"),
      animalsAddBtn = document.querySelector("#animals-add-btn"),
      adultsCountEl = document.querySelector("#guests-count-adults"),
      childrenCountEl = document.querySelector("#guests-count-children");
    smallChildrenCountEl = document.querySelector(
      "#guests-count-small-children"
    );
    animalsCountEl = document.querySelector("#guests-count-animals");
    //**** FEWO CLOUD ****
    formSearchAdults = document.querySelector("#form-search-adults");
    formSearchChildren = document.querySelector("#form-search-children");
    formSearchInfants = document.querySelector("#form-search-infants");
    formSearchAnimals = document.querySelector("#form-search-pets");
    //**** FEWO CLOUD ****
    if ($("#form-search-maxNumGuests").val() > 0)
      maxNumGuests = $("#form-search-maxNumGuests").val();
    else maxNumGuests = 30;

    if ($("#form-search-maxNumPets").val() > 0)
      maxNumPets = $("#form-search-maxNumPets").val();
    else maxNumPets = 30;

    let isGuestInputOpen = false,
      adultsCount = adults,
      childrenCount = children,
      smallChildrenCount = infants,
      animalsCount = pets;

    guestBtn[i].addEventListener("click", function (e) {
      if (isGuestInputOpen) {
        guestBtn[i].classList.remove("open");
        guestOptions.classList.remove("open");
      } else {
        guestBtn[i].classList.add("open");
        guestOptions.classList.add("open");
      }
      isGuestInputOpen = isGuestInputOpen ? false : true;
      e.preventDefault();
    });

    adultsAddBtn.addEventListener("click", function () {
      adultsCount = addValues(adultsCount);
      updateValues();
    });
    adultsSubsBtn.addEventListener("click", function () {
      adultsCount = substractValues(adultsCount, 1);
      updateValues();
    });
    childrenAddBtn.addEventListener("click", function () {
      childrenCount = addValues(childrenCount);
      updateValues();
    });
    childrenSubsBtn.addEventListener("click", function () {
      childrenCount = substractValues(childrenCount, 0);
      updateValues();
    });
    smallChildrenAddBtn.addEventListener("click", function () {
      smallChildrenCount = addValues(smallChildrenCount);
      updateValues();
    });
    smallChildrenSubsBtn.addEventListener("click", function () {
      smallChildrenCount = substractValues(smallChildrenCount, 0);
      updateValues();
    });
    animalsAddBtn.addEventListener("click", function () {
      animalsCount = addValuesAnimal(animalsCount);
      updateValues();
    });
    animalsSubsBtn.addEventListener("click", function () {
      animalsCount = substractValuesAnimal(animalsCount, 0);
      updateValues();
    });

    function calcTotalGuests() {
      return adultsCount + childrenCount + smallChildrenCount;
    }

    function addValues(count) {
      return calcTotalGuests() < maxNumGuests ? count + 1 : count;
    }

    function substractValues(count, min) {
      return count > min ? count - 1 : count;
    }

    function addValuesAnimal(count) {
      return animalsCount < maxNumPets ? count + 1 : count;
    }

    function substractValuesAnimal(count, min) {
      return count > min ? count - 1 : count;
    }

    function updateValues() {
      let btnText =
        adultsCount == 1
          ? `${adultsCount} ${adultSingular}`
          : `${adultsCount} ${adultPlural}`;
      btnText +=
        childrenCount == 1 ? `, ${childrenCount} ${childSingular}` : "";
      btnText += childrenCount > 1 ? `, ${childrenCount} ${childPlural}` : "";
      btnText +=
        smallChildrenCount == 1
          ? `, ${smallChildrenCount} ${infantSingular}`
          : "";
      btnText +=
        smallChildrenCount > 1 ? `, ${smallChildrenCount} ${infantPlural}` : "";
      btnText += animalsCount == 1 ? `, ${animalsCount} ${animalSingular}` : "";
      btnText += animalsCount > 1 ? `, ${animalsCount} ${animalPlural}` : "";
      guestBtn[i].value = btnText;
      adultsCountEl.innerHTML = adultsCount;
      childrenCountEl.innerHTML = childrenCount;
      smallChildrenCountEl.innerHTML = smallChildrenCount;
      animalsCountEl.innerHTML = animalsCount;
      //**** FEWO CLOUD ****
      formSearchAdults.value = adultsCount;
      formSearchChildren.value = childrenCount;
      formSearchInfants.value = smallChildrenCount;
      formSearchAnimals.value = animalsCount;
      //**** FEWO CLOUD ****

      if (adultsCount == 1) {
        adultsSubsBtn.classList.add("disabled");
      } else {
        adultsSubsBtn.classList.remove("disabled");
      }
      if (childrenCount == 0) {
        childrenSubsBtn.classList.add("disabled");
      } else {
        childrenSubsBtn.classList.remove("disabled");
      }
      if (smallChildrenCount == 0) {
        smallChildrenSubsBtn.classList.add("disabled");
      } else {
        smallChildrenSubsBtn.classList.remove("disabled");
      }
      if (animalsCount == 0) {
        animalsSubsBtn.classList.add("disabled");
      } else {
        animalsSubsBtn.classList.remove("disabled");
      }
      if (calcTotalGuests() == maxNumGuests) {
        adultsAddBtn.classList.add("disabled");
        childrenAddBtn.classList.add("disabled");
        smallChildrenAddBtn.classList.add("disabled");
      } else {
        adultsAddBtn.classList.remove("disabled");
        childrenAddBtn.classList.remove("disabled");
        smallChildrenAddBtn.classList.remove("disabled");
      }
      if (animalsCount == maxNumPets) {
        animalsAddBtn.classList.add("disabled");
      } else {
        animalsAddBtn.classList.remove("disabled");
      }
    }
  }
}
